module.exports = __webpack_public_path__ + "img/5.d78ae216.jpg";